export const TIMEOUT = 80; // seconds
export const PIN_LENGTH = 6; // numbers
